import React, { Component } from "react";
import ReactDOM from "react-dom";
import KpsListItem from "../../core-elements/KpsListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { Trans, withTranslation } from "react-i18next";
import { withStyles, withTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import AssignmentLateIcon from "@material-ui/icons/AssignmentLate";
import { EDIT_SELECTED } from "../../utils/Topics";
import PubSub from "pubsub-js";
import moment from "moment";
import { connect } from "react-redux";
import DisplayUser from "../user/DisplayUser";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";

const styles = (theme) => ({
  iconSpan: {
    "& > svg": {
      verticalAlign: "middle",
    },
  },
  secondarySpan: {
    verticalAlign: "middle",
    // marginLeft: "5px"
  },
  revisionAvatar: {
    height: theme.spacing(3),
    width: theme.spacing(3),
    marginRight: theme.spacing(1),
    // marginTop: theme.spacing(1),
    fontSize: "small",
    backgroundColor: theme.palette.grey[600],
  },
});
export class ItemContentRevision extends Component {
  state = {
    extendedString: "",
  };

  componentDidMount() {
    this.extendedInfo(this.props.extendedSettings);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.extendedSettings &&
      prevProps.extendedSettings !== this.props.extendedSettings
    ) {
      this.extendedInfo(this.props.extendedSettings);
    }
  }

  render() {
    const { classes } = this.props;
    let secondarySetting = this.props.secondarySetting || "createdDate";
    const child = (
      <KpsListItem
        preText={this.props.preText}
        isPortlet={this.props.isPortlet}
        onItemClick={() => this.onItemClick(this.props.data)}
        extendedString={this.state.extendedString}
        provided={this.props.provided}
        hideExpand={this.props.isMobile && this.props.timeline}
      >
        <ListItemText
          disableTypography={true}
          style={{ overflowWrap: "anywhere" }}
          primary={
            <Box display="flex">
              <Avatar
                variant="rounded"
                classes={{ root: classes.revisionAvatar }}
              >
                {this.props.data.revisionNumber}
              </Avatar>
              <div>{this.props.data.title}</div>
            </Box>
          }
          secondary={
            (!this.props.isMobile || !this.props.timeline) &&
            this.secondaryInfo(secondarySetting)
          }
        />
      </KpsListItem>
    );
    if (this.props.snapshot && this.props.snapshot.isDragging) {
      return ReactDOM.createPortal(child, document.body);
    }
    return child;
  }
  onItemClick = (revision) => {
    PubSub.publish(EDIT_SELECTED, this.props.data);
    this.props.onItemClick(revision);
  };
  extendedInfo(settingsFull) {
    const { classes } = this.props;
    if (!settingsFull) {
      settingsFull = [];
      for (let i = 0; i < this.props.revisionOptions.length; i++) {
        settingsFull.push({ label: this.props.revisionOptions[i], order: i });
      }
    } else {
      settingsFull = JSON.parse(settingsFull);
    }
    var extendedString = (
      <>
        {[...new Set(settingsFull)].map((setting, idx) => {
          return (
            <TableRow>
              <TableCell>{this.props.t(setting.label)}</TableCell>
              {setting.label === "settings_content_revision_revision" && (
                <TableCell>{this.props.data.revisionNumber}</TableCell>
              )}
              {setting.label === "knowledgeItemId" && (
                <TableCell>{this.props.data.knowledgeItemId}</TableCell>
              )}
              {setting.label === "settings_content_revision_author" && (
                <TableCell>
                  <DisplayUser
                    userId={this.props.data.author.userId}
                    user={this.props.data.author}
                  />
                </TableCell>
              )}
              {setting.label === "settings_content_revision_approved" && (
                <TableCell>
                  {this.props.data.approved === 1 ? (
                    <CheckIcon />
                  ) : (
                    <CloseIcon />
                  )}
                </TableCell>
              )}
              {setting.label === "settings_content_revision_created_date" && (
                <TableCell>{moment(this.props.data.createdDate).format("DD/MM/YYYY")}</TableCell>
              )}
              {setting.label === "settings_content_revision_approved_date" && (
                <TableCell>
                  {this.props.data.approvedDate !== null 
                    ? moment(this.props.data.approvedDate).format("DD/MM/YYYY")
                    : ""
                  }
                </TableCell>
              )}
              {setting.label === "settings_content_revision_meta" && (
                <TableCell>{this.props.data.meta}</TableCell>
              )}
              {setting.label ===
                "settings_content_revision_ready_for_approval" && (
                <TableCell>{this.props.data.isReadyForApproval}</TableCell>
              )}
              {setting.label ===
                "settings_content_revision_ready_for_approval_date" && (
                <TableCell>
                  {this.props.data.readyForApprovalDate !== null 
                    ? moment(this.props.data.readyForApprovalDate).format("DD/MM/YYYY")
                    : ""
                  }
                </TableCell>
              )}
              {setting.label === "settings_content_revision_is_live" && (
                <TableCell>
                  {this.props.data.isLive ? <CheckIcon /> : <CloseIcon />}
                </TableCell>
              )}
              {setting.label === "settings_content_revision_rationale" && (
                <TableCell>{this.props.data.rationale}</TableCell>
              )}
              {setting.label === "settings_content_revision_layout" && (
                <TableCell>{this.props.data.layout}</TableCell>
              )}
            </TableRow>
          );
        })}
      </>
    );
    this.setState({ extendedString });
  }
  returnSettingItem = (settings) => {
    const { classes, theme } = this.props;
    let fontWeight = { fontWeight: this.props.fullscreen ? "bold" : "normal" };
    return (
      <span className={classes.secondarySpan}>
        {settings === "revision" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_content_revision_revision")}
            </div>
            <div>: {this.props.data.revisionNumber}&nbsp;</div>
          </div>
        )}
        {settings === "author" && (
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginLeft: theme.spacing(4),
                alignItems: "center",
              }}
            >
              <div style={fontWeight}>
                {this.props.t("settings_content_revision_author")}
              </div>
              <div style={{ marginLeft: theme.spacing(2) }}>
                <DisplayUser
                  noAvatar
                  userId={this.props.data.author.userId}
                  user={this.props.data.author}
                />
              </div>
            </div>
            <div style={{ marginLeft: theme.spacing(4) }}>
              {moment(this.props.data.createdDate).fromNow()}
            </div>
          </>
        )}
        {settings === "approved" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_content_revision_approved")}
            </div>
            <div>: {this.props.data.approved}&nbsp;</div>
          </div>
        )}
        {settings === "createdDate" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_content_revision_created_date")}
            </div>
            <div>
              : {moment(this.props.data.createdDate).format("DD/MM/YYYY")}&nbsp;
            </div>
          </div>
        )}
        {settings === "createdDateTime" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_content_revision_created_date")}
            </div>
            <div>
              : {moment(this.props.data.createdDate).format("DD/MM/YYYY HH:mm")}&nbsp;
            </div>
          </div>
        )}
        {settings === "approvedDate" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_content_revision_approved_date")}
            </div>
            <div>: {this.props.data.approvedDate}&nbsp;</div>
          </div>
        )}
        {settings === "meta" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_content_revision_meta")}
            </div>
            <div>: {this.props.data.meta}&nbsp;</div>
          </div>
        )}
        {settings === "isReadyForApproval" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_content_revision_ready_for_approval")}
            </div>
            <div>: {this.props.data.isReadyForApproval}&nbsp;</div>
          </div>
        )}
        {settings === "readyForApprovalDate" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t(
                "settings_content_revision_ready_for_approval_date"
              )}
            </div>
            <div>: {this.props.data.readyForApprovalDate}&nbsp;</div>
          </div>
        )}
        {settings === "isLive" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_content_revision_is_live")}
            </div>
            <div>: {this.props.data.isLive}&nbsp;</div>
          </div>
        )}
        {settings === "rationale" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_content_revision_rationale")}
            </div>
            <div>: {this.props.data.rationale}&nbsp;</div>
          </div>
        )}
        {settings === "layout" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_content_revision_layout")}
            </div>
            <div>: {this.props.data.layout}&nbsp;</div>
          </div>
        )}
        {settings === "workflowState" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_content_revision_workflowState")}
            </div>
            <div>: {this.props.data.workflowState 
              ? this.props.data.workflowState === "PUBLISHED"  
                ? this.props.data.isLive === true 
                  ? this.props.t("global_live")
                  : this.props.t("workflow_superceded")  
                : this.props.t("workflow_" + this.props.data.workflowState.toLowerCase())
              : this.props.t("workflow_being_edited")}&nbsp;</div>
          </div>
        )}
      </span>
    );
  };
  secondaryInfo(settings) {
    if (this.props.secondaryInfo) {
      return this.props.secondaryInfo;
    }
    if (this.props.fullscreen) {
      if (!this.props.fullscreenSettings) {
        settings = [];
        for (let i = 0; i < this.props.revisionOptions.length; i++) {
          settings.push({ label: this.props.revisionOptions[i], order: i });
        }
      } else {
        settings = JSON.parse(settings);
      }
    } else if (!settings) {
      settings = "settings_content_revision_author";
    }
    const { classes } = this.props;
    return (
      <div>
        <span className={classes.iconSpan}>
          {this.props.data.isReadyForApproval && (
            <Tooltip
              title={this.props.t("ready_for_approval")}
              aria-label={this.props.t("ready_for_approval")}
            >
              <AssignmentLateIcon color="secondary" />
            </Tooltip>
          )}
        </span>
        {this.props.fullscreen
          ? settings.map((setting) => {
              return this.returnSettingItem(setting);
            })
          : this.returnSettingItem(settings)}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  revisionOptions: state.selectionOption.contentRevisionSettingsOptions,
  isMobile: state.screen.isMobile,
});
export default connect(
  mapStateToProps,
  null
)(withTheme(withStyles(styles)(withTranslation()(ItemContentRevision))));
